import { baseStaticUrl } from "../../../../config";
import { useQuery } from "@tanstack/react-query";
import englishTranslations from "../../../i18n/english_translations.json";
import messagesByKey from "../../../i18n/refactored_translations";

export const useLanguageTranslations = (languageKey) => {
  const { data } = useQuery({
    queryKey: "translations",
    queryFn: () =>
      fetch(
        `${baseStaticUrl}/i18n/cxweb/${languageKey.replace("-", "_")}.json`
      ).then((res) => res.json()),
    staleTime: Infinity,
  });

  return {
    ...englishTranslations,
    ...data,
    ...messagesByKey[languageKey],
  };
};
